import { Button, Spinner } from "@chakra-ui/react";
import { t } from '@lang/i18n';

const LoadMore = ({ showMore, loading_more }) => {
    return(
        <Button 
            size="xs"
            bg="white"
            color="black"
            boxShadow="2px 2px 20px 5px #00000026" 
            _hover={{opacity: .8}}
            fontWeight="normal" 
            borderRadius="99" 
            mx="auto" mt="40px" w="120px"
            onClick={showMore}>
            {loading_more? <Spinner size="sm" /> : t('candidate.search_job.main.show_more')}
        </Button>
    )   
}

export default LoadMore;